export default __webpack_public_path__ + "static/media/person-shirt-green.a41887ec.svg";